import React from 'react';
import { Topright, FirstInfo, Box, TopInfo, LeftInfo, RightInfo, BottomInfo, Title } from './styles';

const AdditionalInfoLoading: React.FC = () => {
  return (
    <Topright>
      <Title>Additional Info</Title>
      <Box className='secondBox'>
        <FirstInfo>
          <TopInfo>
            <LeftInfo className='loading-animation' />
            <RightInfo className='loading-animation' />
          </TopInfo>
          <BottomInfo className='loading-animation' />
        </FirstInfo>
        <FirstInfo>
          <TopInfo>
            <LeftInfo className='loading-animation' />
          </TopInfo>
          <BottomInfo className='loading-animation' />
        </FirstInfo>
        <FirstInfo>
          <TopInfo>
            <LeftInfo className='loading-animation' />
          </TopInfo>
          <BottomInfo className='loading-animation' />
        </FirstInfo>
        <FirstInfo>
          <TopInfo>
            <LeftInfo className='loading-animation' />
          </TopInfo>
          <BottomInfo className='loading-animation' />
        </FirstInfo>
      </Box>
    </Topright>
  );
};

export default AdditionalInfoLoading;
